import { useState } from 'react';
import { Toasts } from 'components/toasts';
import { Button } from 'components/button';
import { client } from 'utilities/db';
import { RenderIf } from 'utilities/helpers';
import { useQueryClientHook } from 'hooks/queryClientHook';
import { useFetchRequestsAgainstUser } from 'hooks/cloud/useFetchRequestsAgainstUser';
import { useStore } from 'store';
import { ThemeTabs } from 'components/tabs';
import styles from './index.module.css';
import { Loading } from 'components/loading';

export const ViewConnectionsForBrand = ({ setRequestModal }) => {
  const [markupData, setMarkupData] = useState(null);

  const { user } = useStore((state) => state);

  const { brandRequestData, brandRequestLoading, brandRequestRefetch } =
    useFetchRequestsAgainstUser(`brand/requests`, user?.id);

  const [queryClient] = useQueryClientHook();

  const handleUpdateMarkup = async () => {
    try {
      const { id, markup } = markupData;
      let response = await client.post(
        `/cloudKitchen/updateCloudKitchenMarkUp/${id}`,
        {
          markup: parseInt(markup)
        }
      );
      response = response.data;
      brandRequestRefetch();
      Toasts.success('Markup updated successfully');
      setMarkupData(null);
    } catch (error) {
      Toasts.error(error?.response?.data?.message);
    }
  };

  const handleUpdateStatus = async (id, status) => {
    try {
      let response = await client.post(
        `/cloudKitchen/updateCloudKitchenStatus/${id}`,
        {
          status,
          user: 'BRAND'
        }
      );
      response = response.data;
      brandRequestRefetch();
      Toasts.success('Status updated successfully');
      setMarkupData(null);
    } catch (error) {
      Toasts.error(error?.response?.data?.message);
    }
  };

  return (
    <div className={styles.modal_box}>
      <h3>
        <span className="ff_semi">View Recieved Partnership Requests</span>
      </h3>
      <RenderIf isTrue={brandRequestLoading}>
        <div className={`loading_full`}>
          <Loading />
        </div>
      </RenderIf>
      <RenderIf isTrue={!brandRequestLoading && brandRequestData}>
        {/* <h6>
          <strong>Requests Recieved</strong>
        </h6> */}
        <div className="mt_20"></div>
        <ThemeTabs
          tabs={[
            { label: 'Waiting' },
            { label: 'Pending' },
            { label: 'Accepted' },
            { label: 'Rejected' }
          ]}
          panels={[
            {
              content: (
                <WaitingRequest
                  brandRequestData={brandRequestData}
                  handleUpdateStatus={handleUpdateStatus}
                  handleUpdateMarkup={handleUpdateMarkup}
                  markupData={markupData}
                  setMarkupData={setMarkupData}
                />
              )
            },
            {
              content: (
                <PendingRequest
                  brandRequestData={brandRequestData}
                  handleUpdateStatus={handleUpdateStatus}
                  handleUpdateMarkup={handleUpdateMarkup}
                  markupData={markupData}
                  setMarkupData={setMarkupData}
                />
              )
            },
            {
              content: <AcceptedRequest brandRequestData={brandRequestData} />
            },
            {
              content: <RejectedRequest brandRequestData={brandRequestData} />
            }
          ]}
          isSearch={<div></div>}
        />
      </RenderIf>
    </div>
  );
};

export const WaitingRequest = ({
  brandRequestData,
  handleUpdateStatus,
  handleUpdateMarkup,
  markupData,
  setMarkupData
}) => {
  return (
    <>
      {brandRequestData
        ?.filter((request) => request?.status === 'WAITING')
        ?.map((request) => {
          return (
            <div className="shadow_box p10 mb_8">
              <div className={styles.item_request}>
                <p className="f12">
                  Request recived for {request?.BrandModel?.brand_name} for
                  branch {request?.BranchModel?.branch_name} at markup of{' '}
                  <span color="primary">
                    <b>{request?.markup}</b>
                  </span>{' '}
                  with status{' '}
                  <span color="primary">
                    <b>{request?.status}</b>
                  </span>
                </p>
                <div className={styles.buttons}>
                  <RenderIf isTrue={request?.status_brand === 'No'}>
                    <Button
                      label="Revise Markup"
                      color="outline-titary"
                      className="button button_radius button_sm"
                      onClick={() =>
                        setMarkupData({
                          id: request?.id,
                          markup: request?.markup
                        })
                      }
                    />
                    <Button
                      label="Accept Request"
                      color="bg-titary"
                      className="button button_radius button_sm"
                      onClick={() =>
                        handleUpdateStatus(request?.id, 'ACCEPTED')
                      }
                    />
                    <Button
                      label="Reject Request"
                      color="outline-danger"
                      className="button button_radius button_sm"
                      onClick={() =>
                        handleUpdateStatus(request?.id, 'REJECTED')
                      }
                    />
                  </RenderIf>
                  <RenderIf isTrue={markupData}>
                    <input
                      type="number"
                      onChange={(e) =>
                        setMarkupData({
                          ...markupData,
                          markup: parseInt(e.target.value)
                        })
                      }
                      defaultValue={request?.markup}
                      className={styles.input_markup}
                    />
                    <Button
                      label="Send Revised Markup"
                      color="bg-titary"
                      className="button button_radius button_sm"
                      onClick={handleUpdateMarkup}
                    />
                  </RenderIf>
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
};

export const PendingRequest = ({
  brandRequestData,
  handleUpdateStatus,
  handleUpdateMarkup,
  markupData,
  setMarkupData
}) => {
  return (
    <>
      {brandRequestData
        ?.filter((request) => request?.status === 'PENDING')
        ?.map((request) => {
          return (
            <div className="shadow_box p10 mb_8">
              <div className={styles.item_request}>
                <p className="f12">
                  Request recived for {request?.BrandModel?.brand_name} for
                  branch {request?.BranchModel?.branch_name} at markup of{' '}
                  <span color="primary">
                    <b>{request?.markup}</b>
                  </span>{' '}
                  with status{' '}
                  <span color="primary">
                    <b>{request?.status}</b>
                  </span>
                </p>
                <div className={styles.buttons}>
                  <RenderIf isTrue={request?.status_brand === 'No'}>
                    <Button
                      label="Revise Markup"
                      color="outline-titary"
                      className="button button_radius button_sm"
                      onClick={() =>
                        setMarkupData({
                          id: request?.id,
                          markup: request?.markup
                        })
                      }
                    />
                    <Button
                      label="Accept Request"
                      color="bg-titary"
                      className="button button_radius button_sm"
                      onClick={() =>
                        handleUpdateStatus(request?.id, 'ACCEPTED')
                      }
                    />
                    <Button
                      label="Reject Request"
                      color="outline-danger"
                      className="button button_radius button_sm"
                      onClick={() =>
                        handleUpdateStatus(request?.id, 'REJECTED')
                      }
                    />
                  </RenderIf>
                  <RenderIf isTrue={markupData}>
                    <input
                      type="number"
                      onChange={(e) =>
                        setMarkupData({
                          ...markupData,
                          markup: parseInt(e.target.value)
                        })
                      }
                      defaultValue={request?.markup}
                      className={styles.input_markup}
                    />
                    <Button
                      label="Send Revised Markup"
                      color="bg-titary"
                      className="button button_radius button_sm"
                      onClick={handleUpdateMarkup}
                    />
                  </RenderIf>
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
};

export const AcceptedRequest = ({ brandRequestData }) => {
  return (
    <>
      {brandRequestData
        ?.filter((request) => request?.status === 'ACCEPTED')
        ?.map((request) => {
          return (
            <div className="shadow_box p10 mb_8">
              <p className="f12">
                Request recived for {request?.BrandModel?.brand_name} for branch{' '}
                {request?.BranchModel?.branch_name} at markup of{' '}
                <span color="primary">
                  <b>{request?.markup}</b>
                </span>{' '}
                with status{' '}
                <span color="primary">
                  <b>{request?.status}</b>
                </span>
              </p>
            </div>
          );
        })}
    </>
  );
};

export const RejectedRequest = ({ brandRequestData }) => {
  return (
    <>
      {brandRequestData
        ?.filter((request) => request?.status === 'REJECTED')
        ?.map((request) => {
          return (
            <div className="shadow_box p10 mb_8">
              <p className="f12">
                Request recived for {request?.BrandModel?.brand_name} for branch{' '}
                {request?.BranchModel?.branch_name} at markup of{' '}
                <span color="primary">
                  <b>{request?.markup}</b>
                </span>{' '}
                with status{' '}
                <span color="primary">
                  <b>{request?.status}</b>
                </span>
              </p>
            </div>
          );
        })}
    </>
  );
};
